// // // import React, { useState } from "react";
// // // import { motion } from "framer-motion";
// // // import confetti from "canvas-confetti";

// // // export default function SalesFightArena() {

// // //   const [boom, setBoom] = useState(false);
// // //   const [shake, setShake] = useState(false);

// // //   const [powerA, setPowerA] = useState(100);
// // //   const [powerB, setPowerB] = useState(100);

// // //   const [combo, setCombo] = useState(0);

// // //   const [salesA, setSalesA] = useState(0);
// // //   const [salesB, setSalesB] = useState(0);

// // //   const [winner, setWinner] = useState(null);

// // //   const [impactText, setImpactText] = useState("");

// // //   const impactWords = [
// // //     "BOOM 💥",
// // //     "DIRECT SALE 🎯",
// // //     "CRITICAL HIT ⚡",
// // //     "POWER CLOSE 💰",
// // //     "KNOCKDOWN 🔥"
// // //   ];

// // //   const fireConfetti = () => {
// // //     confetti({
// // //       particleCount: 200,
// // //       spread: 100,
// // //       startVelocity: 60,
// // //       origin: { y: 0.6 }
// // //     });
// // //   };

// // //   const punch = () => {

// // //     if (winner) return;

// // //     setBoom(true);
// // //     setShake(true);

// // //     setCombo((c) => c + 1);

// // //     const randomImpact =
// // //       impactWords[Math.floor(Math.random() * impactWords.length)];

// // //     setImpactText(randomImpact);

// // //     fireConfetti();

// // //     setPowerB((v) => {
// // //       const newPower = Math.max(v - 15, 0);

// // //       if (newPower === 0) {
// // //         setWinner("ANAND");
// // //       }

// // //       return newPower;
// // //     });

// // //     setSalesA((v) => v + 1);

// // //     setTimeout(() => {
// // //       setBoom(false);
// // //       setShake(false);
// // //     }, 700);
// // //   };

// // //   return (
// // //     <div className="h-screen w-full bg-gradient-to-b from-[#020617] via-[#020617] to-black flex flex-col items-center justify-center overflow-hidden relative">

// // //       {/* ARENA LIGHT */}
// // //       <div className="absolute w-[1200px] h-[600px] bg-blue-500/10 blur-[160px]" />
// // //       <div className="absolute w-[1000px] h-[500px] bg-purple-500/10 blur-[150px]" />

// // //       {/* HEALTH BARS */}
// // //       <div className="absolute top-8 w-full flex justify-between px-32">

// // //         <div className="w-[35%]">
// // //           <div className="text-white font-bold mb-2 text-lg">🏆 ANAND</div>

// // //           <div className="bg-gray-700 h-5 rounded overflow-hidden">
// // //             <motion.div
// // //               className="h-full bg-green-500"
// // //               animate={{ width: `${powerA}%` }}
// // //             />
// // //           </div>
// // //         </div>

// // //         <div className="w-[35%] text-right">
// // //           <div className="text-white font-bold mb-2 text-lg">💪 RAHUL</div>

// // //           <div className="bg-gray-700 h-5 rounded overflow-hidden">
// // //             <motion.div
// // //               className="h-full bg-red-500"
// // //               animate={{ width: `${powerB}%` }}
// // //             />
// // //           </div>
// // //         </div>

// // //       </div>

// // //       {/* SALES SCOREBOARD */}
// // //       <div className="absolute top-28 flex gap-24 text-white text-2xl font-bold">

// // //         <div className="text-center">
// // //           <div>ANAND</div>
// // //           <div className="text-yellow-400 text-4xl">{salesA}</div>
// // //           <div className="text-sm text-gray-400">Manager: Rajesh</div>
// // //         </div>

// // //         <div className="text-center">
// // //           <div>RAHUL</div>
// // //           <div className="text-red-400 text-4xl">{salesB}</div>
// // //           <div className="text-sm text-gray-400">Manager: Vikram</div>
// // //         </div>

// // //       </div>

// // //       {/* FIGHTERS */}
// // //       <motion.div
// // //         animate={shake ? { x: [-12, 12, -8, 8, 0] } : { x: 0 }}
// // //         transition={{ duration: 0.35 }}
// // //         className="flex items-end gap-56 relative"
// // //       >

// // //         {/* LEFT FIGHTER */}
// // //         <motion.img
// // //           src="/fighter/anand.png"
// // //           className="w-[420px] drop-shadow-[0_30px_60px_rgba(0,0,0,0.8)]"
// // //           animate={boom ? { x: 200, rotate: -6 } : { x: 0 }}
// // //           transition={{ type: "spring", stiffness: 250 }}
// // //         />

// // //         {/* IMPACT TEXT */}
// // //         {boom && (
// // //           <motion.div
// // //             initial={{ scale: 0, y: -40 }}
// // //             animate={{ scale: 1.4, y: 0 }}
// // //             className="absolute text-[90px] font-black text-yellow-400 drop-shadow-lg"
// // //           >
// // //             {impactText}
// // //           </motion.div>
// // //         )}

// // //         {/* RIGHT FIGHTER */}
// // //         <motion.img
// // //           src="/fighter/rahul.png"
// // //           className="w-[420px] drop-shadow-[0_30px_60px_rgba(0,0,0,0.8)]"
// // //           animate={boom ? { x: 120, rotate: 10 } : { x: 0 }}
// // //           transition={{ type: "spring", stiffness: 180 }}
// // //         />

// // //       </motion.div>

// // //       {/* COMBO TEXT */}
// // //       {combo > 1 && (
// // //         <motion.div
// // //           initial={{ scale: 0 }}
// // //           animate={{ scale: 1.3 }}
// // //           className="absolute bottom-36 text-yellow-400 text-4xl font-extrabold"
// // //         >
// // //           COMBO x{combo}
// // //         </motion.div>
// // //       )}

// // //       {/* BUTTON */}
// // //       <motion.button
// // //         whileHover={{ scale: 1.1 }}
// // //         whileTap={{ scale: 0.9 }}
// // //         onClick={punch}
// // //         className="absolute bottom-12 bg-green-500 hover:bg-green-600 text-white px-12 py-4 rounded-xl text-xl font-bold shadow-lg"
// // //       >
// // //         New Sale 🎯
// // //       </motion.button>

// // //       {/* WINNER SCREEN */}
// // //       {winner && (
// // //         <motion.div
// // //           initial={{ opacity: 0 }}
// // //           animate={{ opacity: 1 }}
// // //           className="absolute inset-0 bg-black/90 flex flex-col items-center justify-center z-50"
// // //         >

// // //           <img
// // //             src="/fighter/anand.png"
// // //             className="w-[520px]"
// // //           />

// // //           <div className="text-yellow-400 text-7xl font-black mt-6">
// // //             🏆 {winner} WINS
// // //           </div>

// // //           <div className="text-white text-2xl mt-4">
// // //             Total Sales: {salesA}
// // //           </div>

// // //         </motion.div>
// // //       )}

// // //     </div>
// // //   );
// // // }


// // import React, { useEffect, useState } from "react";
// // import { motion } from "framer-motion";
// // import confetti from "canvas-confetti";
// // import { FLOOR_HEADS } from "../json/salesTarget.js";

// // export default function SalesFightArena() {

// //   const [salesA, setSalesA] = useState(0);
// //   const [salesB, setSalesB] = useState(0);

// //   const [winner, setWinner] = useState(null);

// //   const managerA = FLOOR_HEADS[0];
// //   const managerB = FLOOR_HEADS[1];

// //   const percentA = Math.min((salesA / managerA.target) * 100, 100);
// //   const percentB = Math.min((salesB / managerB.target) * 100, 100);

// //   const fireConfetti = () => {
// //     confetti({
// //       particleCount: 250,
// //       spread: 120,
// //       startVelocity: 60,
// //       origin: { y: 0.7 }
// //     });
// //   };

// //   // Auto Sales Simulation Every 3s
// //   useEffect(() => {

// //     const interval = setInterval(() => {

// //       if (winner) return;

// //       setSalesA(v => v + Math.floor(Math.random() * 120));
// //       setSalesB(v => v + Math.floor(Math.random() * 120));

// //     }, 3000);

// //     return () => clearInterval(interval);

// //   }, [winner]);

// //   // Check Winner
// //   useEffect(() => {

// //     if (winner) return;

// //     if (percentA >= 100 || percentB >= 100) {

// //       const w = percentA >= percentB ? managerA : managerB;

// //       setWinner(w);

// //       fireConfetti();

// //       // Reset Loop After 6s
// //       setTimeout(() => {

// //         setWinner(null);
// //         setSalesA(0);
// //         setSalesB(0);

// //       }, 6000);

// //     }

// //   }, [percentA, percentB, winner]);

// //   return (
// //     <div className="h-screen w-full bg-gradient-to-b from-[#020617] via-[#020617] to-black flex items-center justify-center relative overflow-hidden">

// //       {/* ARENA LIGHT */}
// //       <div className="absolute w-[1200px] h-[600px] bg-blue-500/10 blur-[160px]" />
// //       <div className="absolute w-[1000px] h-[500px] bg-purple-500/10 blur-[150px]" />

// //       {/* SCORE AREA */}
// //       <div className="absolute top-16 flex gap-40 text-white">

// //         {/* Manager A */}
// //         <div className="text-center w-80">

// //           <img
// //             src={managerA.photo}
// //             className="w-40 h-40 rounded-full mx-auto object-cover border-4 border-green-400"
// //           />

// //           <div className="text-2xl font-bold mt-4">
// //             {managerA.name}
// //           </div>

// //           <div className="text-gray-400 text-sm">
// //             Target: {managerA.target}
// //           </div>

// //           <div className="bg-gray-700 h-6 rounded mt-4 overflow-hidden">

// //             <motion.div
// //               className="h-full bg-green-500"
// //               animate={{ width: `${percentA}%` }}
// //               transition={{ duration: 1 }}
// //             />

// //           </div>

// //           <div className="mt-2 text-yellow-400 text-xl">
// //             {salesA}
// //           </div>

// //         </div>

// //         {/* Manager B */}
// //         <div className="text-center w-80">

// //           <img
// //             src={managerB.photo}
// //             className="w-40 h-40 rounded-full mx-auto object-cover border-4 border-red-400"
// //           />

// //           <div className="text-2xl font-bold mt-4">
// //             {managerB.name}
// //           </div>

// //           <div className="text-gray-400 text-sm">
// //             Target: {managerB.target}
// //           </div>

// //           <div className="bg-gray-700 h-6 rounded mt-4 overflow-hidden">

// //             <motion.div
// //               className="h-full bg-red-500"
// //               animate={{ width: `${percentB}%` }}
// //               transition={{ duration: 1 }}
// //             />

// //           </div>

// //           <div className="mt-2 text-red-400 text-xl">
// //             {salesB}
// //           </div>

// //         </div>

// //       </div>

// //       {/* VS TEXT */}
// //       <div className="text-white text-8xl font-black opacity-20">
// //         VS
// //       </div>

// //       {/* WINNER SCREEN */}
// //       {winner && (
// //         <motion.div
// //           initial={{ opacity: 0 }}
// //           animate={{ opacity: 1 }}
// //           className="absolute inset-0 bg-black/90 flex flex-col items-center justify-center z-50"
// //         >

// //           <img
// //             src={winner.photo}
// //             className="w-[420px] rounded-full border-8 border-yellow-400"
// //           />

// //           <div className="text-yellow-400 text-7xl font-black mt-6">
// //             🏆 WINNER
// //           </div>

// //           <div className="text-white text-4xl mt-2">
// //             {winner.name}
// //           </div>

// //           <div className="text-gray-300 mt-2 text-xl">
// //             Target Achieved!
// //           </div>

// //         </motion.div>
// //       )}

// //     </div>
// //   );
// // }


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { motion, AnimatePresence } from "framer-motion";
// import confetti from "canvas-confetti";
// import { FLOOR_HEADS , FLOOR_MANAGERS} from "../json/salesTarget.js";
// import { apiurl } from "../config/config.js";

// export default function SalesWarArena() {
//       const today = new Date().toISOString().slice(0, 10);

//       const [loading, setLoading] = useState(false);

//   const managerA = {
//     key: "GMIT",
//     name: "Rahul Bhusan",
//     target: 1000,
//     photo: "/managers/rahulbhusan.jpeg"
//   };

//   const managerB = {
//     key: "ALTF",
//     name: "Anand Suman",
//     target: 1700,
//     photo: "/managers/anandsuman.png"
//   };

//   const [orders, setOrders] = useState({ A: 0, B: 0 });

//   const [winner, setWinner] = useState(null);
//   const [showWinner, setShowWinner] = useState(false);
//   const [electricHit, setElectricHit] = useState(false);
//   const [tick, setTick] = useState(0);

// //   const apiurl = "/api/orders";

//   // fetch orders
//     const fetchSales = async () => {
//       try {
//         const res = await axios.get(`${apiurl}/utils/crm/realTimeOrderData2`, {
//           headers: {
//             token: "ad2355a9d54335e27e2c3a3ed5b6e381",
//             "Content-Type": "application/json",
//           },
//           params: {
//             // from_date: "2026-03-01",
//             from_date: today,
//             to_date: today,
//             //   from_date: fromDate,
//             //   to_date: toDate,
//           },
//         });

//         const list = res?.data?.data?.result?.data?.managers || [];

//         const managerList = res.data?.data?.result?.data?.managers || [];

//         const managerMap = {};

//         managerList.forEach((m) => {
//           managerMap[m.o_manager_name] = Number(m.totalOrders || 0);
//         });

//         const a = list.find((m) => m.o_manager_name === managerA.key);
//         const b = list.find((m) => m.o_manager_name === managerB.key);

//         setOrders({
//           A: Number(a?.totalOrders || 0),
//           B: Number(b?.totalOrders || 0),
//         });

//         /* FIND MANAGER A & B */
//         const aOrders = managerMap[managerA.key] || 0;
//         const bOrders = managerMap[managerB.key] || 0;

//         /* CALCULATE FLOOR TOTALS */
//         const floorTotals = {};

//         Object.keys(FLOOR_MANAGERS).forEach((floor) => {
//           floorTotals[floor] = FLOOR_MANAGERS[floor].reduce(
//             (sum, managerKey) => {
//               return sum + (managerMap[managerKey] || 0);
//             },
//             0,
//           );
//         });

//         /* SAVE EVERYTHING */
//         setOrders({
//           A: aOrders,
//           B: bOrders,
//           ...floorTotals,
//           TOTAL: Number(res.data?.data?.result?.data?.total?.totalOrders || 0),
//         });
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setLoading(false);
//       }
//     };
//   useEffect(() => {
//     fetchSales();
//   }, []);

//   // winner logic
//   const getWinner = () => {

//     const diffA = managerA.target - orders.A;
//     const diffB = managerB.target - orders.B;

//     if (diffA === diffB) return "DRAW";

//     return diffA < diffB ? "A" : "B";
//   };

//   // battle cycle
//   useEffect(() => {

//     const interval = setInterval(() => {

//       fetchSales();

//       const w = getWinner();

//       setWinner(w);

//       setElectricHit(true);

//       setShowWinner(true);

//       confetti({
//         particleCount: 150,
//         spread: 90,
//         origin: { y: 0.6 }
//       });

//       setTimeout(() => {
//         setShowWinner(false);
//         setElectricHit(false);
//       }, 2000);

//       setTick((t) => t + 1);

//     }, 3000);

//     return () => clearInterval(interval);

//   }, [orders]);

//   const progressA = Math.min((orders.A / managerA.target) * 100, 100);
//   const progressB = Math.min((orders.B / managerB.target) * 100, 100);

//   const leaderboard = [
//     { name: managerA.name, orders: orders.A },
//     { name: managerB.name, orders: orders.B }
//   ].sort((a, b) => b.orders - a.orders);

//   return (

//     <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 text-white flex flex-col items-center justify-center p-10 relative overflow-hidden">

//       {/* arena glow */}
//       <div className="absolute w-[1200px] h-[600px] bg-purple-500/20 blur-[160px]" />
//       <div className="absolute w-[900px] h-[500px] bg-blue-500/20 blur-[160px]" />

//       {/* electric flash */}
//       {electricHit && (
//         <motion.div
//           initial={{ opacity: 0 }}
//           animate={{ opacity: [0, 1, 0] }}
//           transition={{ duration: 0.6 }}
//           className="absolute inset-0 bg-white/20 blur-2xl pointer-events-none"
//         />
//       )}

//       {/* fighters */}

//       <div className="flex gap-20 items-center z-10">

//         {/* manager A */}
//         <motion.div
//           animate={winner === "A" ? { scale: [1, 1.1, 1] } : { scale: 1 }}
//           className="bg-white/10 backdrop-blur-xl p-8 rounded-3xl w-72 text-center shadow-xl"
//         >

//           <img
//             src={managerA.photo}
//             className="w-40 h-40 rounded-full object-cover border-4 border-yellow-400 mx-auto"
//           />

//           <h2 className="text-2xl font-bold mt-4">
//             {managerA.name}
//           </h2>

//           <p className="text-sm opacity-70">
//             Target {managerA.target}
//           </p>

//           <div className="mt-4 h-5 bg-gray-700 rounded-full overflow-hidden">
//             <motion.div
//               animate={{ width: `${progressA}%` }}
//               className="h-full bg-green-400"
//             />
//           </div>

//           <p className="text-xl font-bold mt-3">
//             {orders.A} Orders
//           </p>

//         </motion.div>

//         {/* VS */}

//         <motion.div
//           animate={electricHit ? { scale: [1, 1.4, 1] } : { scale: 1 }}
//           className="text-8xl font-extrabold text-yellow-400"
//         >
//           ⚡
//         </motion.div>

//         {/* manager B */}

//         <motion.div
//           animate={winner === "B" ? { scale: [1, 1.1, 1] } : { scale: 1 }}
//           className="bg-white/10 backdrop-blur-xl p-8 rounded-3xl w-72 text-center shadow-xl"
//         >

//           <img
//             src={managerB.photo}
//             className="w-40 h-40 rounded-full object-cover border-4 border-yellow-400 mx-auto"
//           />

//           <h2 className="text-2xl font-bold mt-4">
//             {managerB.name}
//           </h2>

//           <p className="text-sm opacity-70">
//             Target {managerB.target}
//           </p>

//           <div className="mt-4 h-5 bg-gray-700 rounded-full overflow-hidden">
//             <motion.div
//               animate={{ width: `${progressB}%` }}
//               className="h-full bg-blue-400"
//             />
//           </div>

//           <p className="text-xl font-bold mt-3">
//             {orders.B} Orders
//           </p>

//         </motion.div>

//       </div>

//       {/* leaderboard */}

//       <div className="mt-12 bg-white/10 backdrop-blur-xl p-6 rounded-2xl w-[420px]">

//         <h2 className="text-2xl font-bold mb-4 text-center">
//           🏆 Leaderboard
//         </h2>

//         {leaderboard.map((m, i) => (

//           <div
//             key={m.name}
//             className="flex justify-between py-3 border-b border-white/20"
//           >

//             <span>
//               {i === 0 ? "🥇" : "🥈"} {m.name}
//             </span>

//             <span className="font-bold">
//               {m.orders}
//             </span>

//           </div>

//         ))}

//       </div>

//       {/* winner popup */}

//       <AnimatePresence>

//         {showWinner && winner !== "DRAW" && (

//           <motion.div
//             key={tick}
//             initial={{ opacity: 0, scale: 0.6 }}
//             animate={{ opacity: 1, scale: 1 }}
//             exit={{ opacity: 0 }}
//             className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
//           >

//             <div className="bg-white text-black p-12 rounded-3xl text-center shadow-2xl">

//               <img
//                 src={winner === "A" ? managerA.photo : managerB.photo}
//                 className="w-56 h-56 rounded-full object-cover mx-auto border-8 border-yellow-400"
//               />

//               <h2 className="text-4xl font-extrabold mt-6">
//                 {winner === "A" ? managerA.name : managerB.name}
//               </h2>

//               <p className="text-xl mt-2">
//                 Closest To Target 🚀
//               </p>

//               <div className="text-6xl mt-4">
//                 🏆
//               </div>

//             </div>

//           </motion.div>

//         )}

//       </AnimatePresence>

//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import confetti from "canvas-confetti";

import { FLOOR_MANAGERS } from "../json/salesTarget.js";
import { apiurl } from "../config/config.js";

export default function SalesWarArena() {

  const today = new Date().toISOString().slice(0, 10);

  const [orders, setOrders] = useState({
    GMIT: 0,
    ALTF: 0,
    TOTAL: 0
  });

  const [winner, setWinner] = useState(null);
  const [showWinner, setShowWinner] = useState(false);
  const [electricHit, setElectricHit] = useState(false);
  const [tick, setTick] = useState(0);

  const managerA = {
    key: "GMIT",
    name: "Rahul Bhusan",
    target: 1000,
    photo: "/managers/rahulbhusan.jpeg"
  };

  const managerB = {
    key: "ALTF",
    name: "Anand Suman",
    target: 1700,
    photo: "/managers/anandsuman.png"
  };

  /* FETCH SALES */

  const fetchSales = async () => {

    try {

      const res = await axios.get(
        `${apiurl}/utils/crm/realTimeOrderData2`,
        {
          headers: {
            token: "ad2355a9d54335e27e2c3a3ed5b6e381",
            "Content-Type": "application/json"
          },
          params: {
            from_date: today,
            to_date: today
          }
        }
      );

      const managerList =
        res?.data?.data?.result?.data?.managers || [];

      /* CREATE MAP */

      const managerMap = {};

      managerList.forEach((m) => {
        managerMap[m.o_manager_name.trim()] =
          Number(m.totalOrders || 0);
      });

      /* FLOOR TOTALS */

      const floorTotals = {};

      Object.entries(FLOOR_MANAGERS).forEach(
        ([floor, managers]) => {

          floorTotals[floor] = managers.reduce(
            (sum, name) => {

              const orders =
                managerMap[name] || 0;

              return sum + orders;

            },
            0
          );
        }
      );

      /* SAVE STATE */

      setOrders({
        GMIT: floorTotals.GMIT || 0,
        ALTF: floorTotals.ALTF || 0,
        TOTAL:
          Number(
            res?.data?.data?.result?.data?.total
              ?.totalOrders
          ) || 0
      });

    } catch (err) {

      console.error("Sales API Error:", err);

    }
  };

  /* WINNER LOGIC */

  const calculateWinner = (data) => {

    const diffA =
      managerA.target - data.GMIT;

    const diffB =
      managerB.target - data.ALTF;

    if (diffA === diffB) return "DRAW";

    return diffA < diffB ? "A" : "B";
  };

  /* INITIAL LOAD */

  useEffect(() => {

    fetchSales();

  }, []);

  /* BATTLE LOOP */

  useEffect(() => {

    const interval = setInterval(async () => {

      await fetchSales();

      setOrders((prev) => {

        const w = calculateWinner(prev);

        setWinner(w);

        setElectricHit(true);
        setShowWinner(true);

        confetti({
          particleCount: 120,
          spread: 80,
          origin: { y: 0.6 }
        });

        setTimeout(() => {
          setShowWinner(false);
          setElectricHit(false);
        }, 2000);

        setTick((t) => t + 1);

        return prev;
      });

    }, 300000);

    return () => clearInterval(interval);

  }, []);

  /* PROGRESS */

  const progressA = Math.min(
    (orders.GMIT / managerA.target) * 100,
    100
  );

  const progressB = Math.min(
    (orders.ALTF / managerB.target) * 100,
    100
  );

  /* LEADERBOARD */

  const leaderboard = [
    { name: managerA.name, orders: orders.GMIT },
    { name: managerB.name, orders: orders.ALTF }
  ].sort((a, b) => b.orders - a.orders);

  return (

    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 text-white flex flex-col items-center justify-center p-10 relative overflow-hidden">

      {/* arena glow */}

      <div className="absolute w-[1200px] h-[600px] bg-purple-500/20 blur-[160px]" />
      <div className="absolute w-[900px] h-[500px] bg-blue-500/20 blur-[160px]" />

      {/* electric flash */}

      {electricHit && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: [0, 1, 0] }}
          transition={{ duration: 0.6 }}
          className="absolute inset-0 bg-white/20 blur-2xl"
        />
      )}

      {/* fighters */}

      <div className="flex gap-20 items-center z-10">

        {/* GMIT */}

        <motion.div
          animate={
            winner === "A"
              ? { scale: [1, 1.1, 1] }
              : { scale: 1 }
          }
          className="bg-white/10 backdrop-blur-xl p-8 rounded-3xl w-72 text-center shadow-xl"
        >

          <img
            src={managerA.photo}
            className="w-40 h-40 rounded-full border-4 border-yellow-400 mx-auto"
          />

          <h2 className="text-2xl font-bold mt-4">
            {managerA.name}
          </h2>

          <p className="text-sm opacity-70">
            Target {managerA.target}
          </p>

          <div className="mt-4 h-5 bg-gray-700 rounded-full overflow-hidden">

            <motion.div
              animate={{ width: `${progressA}%` }}
              className="h-full bg-green-400"
            />

          </div>

          <p className="text-xl font-bold mt-3">
            {orders.GMIT} Orders
          </p>

        </motion.div>

        {/* VS */}

        <motion.div
          animate={
            electricHit
              ? { scale: [1, 1.4, 1] }
              : { scale: 1 }
          }
          className="text-8xl font-extrabold text-yellow-400"
        >
          ⚡
        </motion.div>

        {/* ALTF */}

        <motion.div
          animate={
            winner === "B"
              ? { scale: [1, 1.1, 1] }
              : { scale: 1 }
          }
          className="bg-white/10 backdrop-blur-xl p-8 rounded-3xl w-72 text-center shadow-xl"
        >

          <img
            src={managerB.photo}
            className="w-40 h-40 rounded-full border-4 border-yellow-400 mx-auto"
          />

          <h2 className="text-2xl font-bold mt-4">
            {managerB.name}
          </h2>

          <p className="text-sm opacity-70">
            Target {managerB.target}
          </p>

          <div className="mt-4 h-5 bg-gray-700 rounded-full overflow-hidden">

            <motion.div
              animate={{ width: `${progressB}%` }}
              className="h-full bg-blue-400"
            />

          </div>

          <p className="text-xl font-bold mt-3">
            {orders.ALTF} Orders
          </p>

        </motion.div>

      </div>

      {/* leaderboard */}

      <div className="mt-12 bg-white/10 backdrop-blur-xl p-6 rounded-2xl w-[420px]">

        <h2 className="text-2xl font-bold mb-4 text-center">
          🏆 Leaderboard
        </h2>

        {leaderboard.map((m, i) => (

          <div
            key={m.name}
            className="flex justify-between py-3 border-b border-white/20"
          >

            <span>
              {i === 0 ? "🥇" : "🥈"} {m.name}
            </span>

            <span className="font-bold">
              {m.orders}
            </span>

          </div>

        ))}

      </div>

      {/* winner popup */}

      <AnimatePresence>

        {showWinner && winner !== "DRAW" && (

          <motion.div
            key={tick}
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
          >

            <div className="bg-white text-black p-12 rounded-3xl text-center shadow-2xl">

              <img
                src={
                  winner === "A"
                    ? managerA.photo
                    : managerB.photo
                }
                className="w-56 h-56 rounded-full border-8 border-yellow-400 mx-auto"
              />

              <h2 className="text-4xl font-extrabold mt-6">

                {winner === "A"
                  ? managerA.name
                  : managerB.name}

              </h2>

              <p className="text-xl mt-2">
                Closest To Target 🚀
              </p>

              <div className="text-6xl mt-4">
                🏆
              </div>

            </div>

          </motion.div>

        )}

      </AnimatePresence>

    </div>
  );
}